const TIPOS_AUTH = [
  {
    id: 0,
    key: 'Local',
    name: 'Local'
  },
  {
    id: 1,
    key: 'AAD',
    name: 'Azure Active Directory'
  },
  {
    id: 2,
    key: 'Mixto',
    name: 'Local + Azure Active Directory',
  },
  {
    id: 3,
    key: 'SAML2',
    name: 'SAML2',
  },
  {
    id: 4,
    key: 'MixtoSAML2',
    name: 'Local + SAML2',
  }
]

export {
  TIPOS_AUTH
}
